import { Heading } from '@99designs/emu';
import { HowItWorksSteps } from '../HowItWorksSteps';
import type { HowItWorksStep } from '../HowItWorksSteps';

export interface HowItWorksProps {
    title: string;
    steps: HowItWorksStep[];
}

export function HowItWorks({ title, steps }: HowItWorksProps) {
    return (
        <>
            <Heading appearanceLevel={4} accessibilityLevel={2}>
                {title}
            </Heading>

            <HowItWorksSteps steps={steps} />
        </>
    );
}
